import { convertRatingToSlug } from 'store/filters/rating-filter-utils';
import { mapTypeToCssClass } from './constants';
const HIGHLIGHTED_Z_INDEX = 10000;
export const updateMarker = ({ marker, spot, isMobile, map, ratingFilters, }) => {
    const { markerType, isHighlighted, isPreviewed } = spot;
    const markerDiv = marker.content;
    const ratingSlug = convertRatingToSlug(spot?.rating);
    if (markerDiv) {
        marker.zIndex =
            isHighlighted || isPreviewed
                ? HIGHLIGHTED_Z_INDEX
                : spot.priorityZIndex ?? null;
        markerDiv.textContent = spot.markerLabelText;
        markerDiv.classList.toggle('previewed', isPreviewed);
        markerDiv.classList.toggle('highlighted', isHighlighted);
        markerDiv.classList.add(mapTypeToCssClass[markerType]);
        // Adds color to the map marker based on rating
        markerDiv.classList.toggle(ratingSlug, ratingFilters.includes(ratingSlug));
    }
    if (!isMobile) {
        marker?.setMap(isPreviewed ? null : map);
    }
};
